module.exports = __webpack_public_path__ + "static/media/angular-quiz.0b88d04f.jpg";